import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=72f3535d"
import script from "./RouteDetail.vue?vue&type=script&lang=js"
export * from "./RouteDetail.vue?vue&type=script&lang=js"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=72f3535d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports